import { gql } from "utils/urql";
import {
  ArticleBylinesFragment,
  ArticleBylinesAuthorFragment,
  ArticleLayout,
} from "types/api";
import cx from "classnames";
import styles from "./ArticleBylines.module.scss";
import Authors from "components/Authors";

const AuthorWrapper = ({ url, displayName }: ArticleBylinesAuthorFragment) => {
  return (
    <a
      className={styles.link}
      href={url}
      data-action="click author - byline"
      data-label={url}
    >
      {displayName}
    </a>
  );
};

const ArticleBylines = ({
  authors,
  secondaryByline,
  layout,
}: ArticleBylinesFragment & { layout: ArticleLayout }) => {
  return (
    <div className={cx(styles.root, layout === "feature" && styles.feature)}>
      <address id="byline">
        {authors.length > 0 && `By `}
        <Authors authors={authors} component={AuthorWrapper} />
        {secondaryByline && (
          <div dangerouslySetInnerHTML={{ __html: secondaryByline }} />
        )}
      </address>
    </div>
  );
};

export default ArticleBylines;

ArticleBylines.fragment = gql`
  fragment articleBylinesAuthor on Author {
    id
    url
    displayName
  }

  fragment articleBylines on Article {
    secondaryByline
    authors {
      ...articleBylinesAuthor
    }
  }
`;
